const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentText extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {
		if (this.initialized) {
			return;
		}
		this.initialized = true;
		const tableElements = this.querySelectorAll('table');
		for (const tableElement of tableElements) {
			const wrapperElement = document.createElement('div');
			wrapperElement.classList.add('table-wrapper');
			this.wrap(tableElement, wrapperElement);
		}
	}

	wrap(element, wrapperElement) {
		element.parentNode.insertBefore(wrapperElement, element);
		wrapperElement.appendChild(element);
	}

}

customElements.define('component-text', ComponentText, {extends: 'div'});

(function ($, Drupal, drupalSettings) {
	const tooltipXClass = 'tippy-x';
	drupalSettings.ckeditor_tooltips.onShow = function (instance) {
		let xElement = instance.popper.querySelector(`.${tooltipXClass}`);
		if (!xElement) {
			xElement = document.createElement('button');
			xElement.classList.add(tooltipXClass);
			xElement.innerHTML = '<span>close tooltip</span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 1L1 15M1 1L15 15" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/></svg>';
			instance.popper.querySelector('.tippy-content').append(xElement);
		}
		if (xElement) {
			xElement.addEventListener('click', () => {
				instance.hide();
			});
		}
	}
	drupalSettings.ckeditor_tooltips.onHide = function (instance) {
		let xElement = instance.popper.querySelector(`.${tooltipXClass}`);
		if (xElement) {
			xElement.removeEventListener('click', () => {
				instance.hide();
			});
		}
	}
})(jQuery, Drupal, drupalSettings);
